import 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { selectFromTheme } from '@thisisbud/sc-utils';
import { notificationIconClassName, WarningNotificationIcon, SuccessNotificationIcon, InfoNotificationIcon, ErrorNotificationIcon, CalloutNotificationIcon } from '@thisisbud/bui-react-notification-icons';
import { h4ClassName, H4 } from '@thisisbud/bui-react-typography';
import { Avatar } from '@thisisbud/bui-react-avatar';
import { jsxs, jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t;
const statusNotificationClassName = 'bui-status-notification';
const statusNotificationIndicatorClassName = `${statusNotificationClassName}__indicator`;
const statusNotificationAvatarClassName = `${statusNotificationClassName}__avatar`;

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledWrapper",
  componentId: "sc-14wok1f-0"
})(_t || (_t = _`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .${0} {
    display: block;
    margin-left: auto;
    margin-right: auto;
    font-size: ${0};
  }

  .${0} {
    margin-left: auto;
    margin-right: auto;
    position: relative;

    .${0} {
      width: ${0};
      height: ${0};
    }

    .${0} {
      position: absolute;
      background-color: ${0};
      border-radius: 50%;
      bottom: 0;
      right: 0;
      transform: translate(${0}, ${0});
      font-size: ${0};

      svg {
        transform: scale(1.1);
      }
    }
  }

  .${0} {
    margin-top: ${0};
  }

  * + & {
    margin-top: ${0};
  }
`), notificationIconClassName, "2.05rem", statusNotificationIndicatorClassName, statusNotificationAvatarClassName, "3.125rem", "3.125rem", notificationIconClassName, selectFromTheme('colorBackgroundCard'), "0.5625rem", "0.125rem", "0.9375rem", h4ClassName, selectFromTheme('spacingMediumDefault'), selectFromTheme('spacingLargeDefault'));
function renderIcon(type, label, id) {
  const iconId = typeof id === 'string' ? `${id}-icon` : undefined;
  switch (type) {
    case 'callout':
      return /*#__PURE__*/jsx(CalloutNotificationIcon, {
        id: iconId,
        label: label
      });
    case 'error':
      return /*#__PURE__*/jsx(ErrorNotificationIcon, {
        id: iconId,
        label: label
      });
    case 'info':
      return /*#__PURE__*/jsx(InfoNotificationIcon, {
        id: iconId,
        label: label
      });
    case 'success':
      return /*#__PURE__*/jsx(SuccessNotificationIcon, {
        id: iconId,
        label: label
      });
    case 'warning':
      return /*#__PURE__*/jsx(WarningNotificationIcon, {
        id: iconId,
        label: label
      });
  }
}
function renderStatusIndicator(type, avatarSrc, label, id) {
  if (typeof avatarSrc !== 'undefined') {
    return /*#__PURE__*/jsxs("div", {
      className: statusNotificationIndicatorClassName,
      children: [/*#__PURE__*/jsx(Avatar, {
        className: statusNotificationAvatarClassName,
        shape: "round",
        src: avatarSrc
      }), renderIcon(type, label, id)]
    });
  }
  return renderIcon(type, label, id);
}

/**
 * Display a notification to the user.
 *
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { StatusNotification } from '@thisisbud/bui-react-status-notification'
 *
 * function Example() {
 *   return (
 *     <StatusNotification
 *       label='Error'
 *       title='Setup failed'
 *       type='error'
 *     >
 *       Lorem ipsum dolore sit amet.
 *     </StatusNotification>
 *   )
 * }
 * ```
 */
function StatusNotification(props) {
  const {
    avatarSrc,
    className,
    children,
    headingLevel,
    id,
    label,
    title,
    type
  } = props;
  const titleId = typeof id === 'string' ? `${id}-title` : undefined;
  return /*#__PURE__*/jsxs(StyledWrapper, {
    className: classnames(statusNotificationClassName, className),
    id: id,
    children: [renderStatusIndicator(type, avatarSrc, label, id), /*#__PURE__*/jsx(H4, {
      align: "center",
      as: `h${headingLevel}`,
      id: titleId,
      children: title
    }), children]
  });
}
StatusNotification.defaultProps = {
  headingLevel: 1,
  type: 'info'
};
StatusNotification.displayName = 'StatusNotification';

export { StatusNotification, statusNotificationAvatarClassName, statusNotificationClassName, statusNotificationIndicatorClassName };
